
import html2pdf from "html2pdf.js";
import moment from "moment";
import React from "react";
import employeeLogo from "../../images/employee.png";

// const InvoicePrint = ({ printRef, state, ledger = "" }) => {
  const InvoicePrint = React.forwardRef(({ state, ledger = "" }, printRef) => {
    console.log("stateeeeee", state)

  console.log("dateee", state.invoiceDate)
    let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl ? baseUrl : employeeLogo;
  console.log("img", imgSrc);
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");

  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");


  // companyNew.partners_logos
  let totalQty = 0;

  const tableHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    backgroundColor: "#333",
    color: "#fff",
    textAlign: "left",
  };
  const tableCellStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  };
 
  const rows = state.items.map((item, i) => (
    <tr style={{ height: "25px" }} key={i}>
      <td style={{ border: "1px solid #000", textAlign: "center", padding: "8px" }}>{i + 1}</td>
      <td style={{ border: "1px solid #000", textAlign: "center", padding: "8px" }}>{item?.name}</td>
      <td style={{ border: "1px solid #000", textAlign: "center", padding: "8px" }}>
        {item?.saleQuantity || 0}
      </td>
      <td style={{ border: "1px solid #000", textAlign: "center", padding: "8px" }}>
        {item?.price % 1 === 0 ? item?.price || 0 : item?.price.toFixed(3)}
      </td>
      <td style={{ border: "1px solid #000", textAlign: "center", padding: "8px" }}>
        {item.saleQuantity ? item.saleQuantity * parseInt(item.price) : item.price || 0}
      </td>
    </tr>
  ));
  
 

return  (
  <>


<div ref={printRef} style={{ fontFamily: "Arial, sans-serif", padding: "20px", backgroundColor: "white" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ flex: 1 }}>
          <img src={imgSrc} alt="Brand Logo" style={{ width: "70px", height: "70px" }} />
          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "bold" }}>{localStorage.getItem("company")}</h2>
        </div>
        <div style={{ flex: 1, textAlign: "right", position: "relative" }}>
          <div
            style={{
              backgroundColor: "#333",
              color: "#fff",
              padding: "10px",
              display: "inline-block",
              borderRadius: "5px",
            }}
          >
            <h3 style={{ margin: 0, fontSize: "18px" }}>INVOICE</h3>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
        <div style={{ flex: 1 }}>
          <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}>Invoice to:</p>
          <p style={{ margin: 0, fontSize: "12px" }}>{state?.ledger?.name || state?.ledger || ""}</p>
          <p style={{ margin: 0, fontSize: "12px" }}>{ledger?.new_ledger?.address || ""}</p>
        </div>
        <div style={{ flex: 1, textAlign: "right" }}>
          <p style={{ margin: 0, fontSize: "12px" }}>
            <strong>Invoice #</strong> {state?.invoiceNumber || ""}
          </p>
          <p style={{ margin: 0, fontSize: "12px" }}>
            {/* <strong>Date</strong> {moment( state.invoiceDate).format("DD-MM-YYYY")} */}
               <strong>Date</strong> {moment(state.invoiceDate, "DD-MM-YYYY").format("DD-MM-YYYY")}

          </p>
        </div>
      </div>

      <div id="invoice" style={{ maxWidth: "800px", margin: "auto", padding: "20px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  textAlign: "center",
                  padding: "8px",
                  backgroundColor: "#333",
                  color: "#fff",
                }}
              >
                No
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  textAlign: "center",
                  padding: "8px",
                  backgroundColor: "#333",
                  color: "#fff",
                }}
              >
                Item
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  textAlign: "center",
                  padding: "8px",
                  backgroundColor: "#333",
                  color: "#fff",
                }}
              >
                Qty
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  textAlign: "center",
                  padding: "8px",
                  backgroundColor: "#333",
                  color: "#fff",
                }}
              >
                Price
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  textAlign: "center",
                  padding: "8px",
                  backgroundColor: "#333",
                  color: "#fff",
                }}
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>

        <div style={{ float: "right", width: "50%" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tr>
              <th style={{ textAlign: "left", padding: "8px" }}>Balance</th>
              <td style={{ textAlign: "right", padding: "8px" }}>
                {state?.ledger?.saleTotal || state?.ledger?.purchaseTotal || 0}
              </td>
            </tr>
            <tr>
              <th style={{ textAlign: "left", padding: "8px" }}>Received</th>
              <td style={{ textAlign: "right", padding: "8px" }}>{state?.recieved || 0}</td>
            </tr>
            <tr>
              <th style={{ textAlign: "left", padding: "8px", fontWeight: "bold" }}>Total</th>
              <td style={{ textAlign: "right", padding: "8px", fontWeight: "bold" }}>
                {Number(state?.total || 0) % 1 === 0
                  ? `${state?.total || 0}`
                  : `${Number(state?.total).toFixed(3)}`}
              </td>
            </tr>
            <tr>
              <th style={{ textAlign: "left", padding: "8px", fontWeight: "bold" }}>Remaining</th>
              <td style={{ textAlign: "right", padding: "8px", fontWeight: "bold" }}>
                {Number(state?.total - state?.recieved || 0) % 1 === 0
                  ? `${state?.total - state?.recieved || 0}`
                  : `${Number(state?.total - state?.recieved || 0).toFixed(3)}`}
              </td>
            </tr>
          </table>
        </div>

        {/* <div style={{ marginTop: "20px" }}>
          <strong>Payment Info:</strong>
          <p style={{ margin: 0 }}>
            Account #: 1234 5678 9012<br />A/C Name: Lorem Ipsum<br />Bank Details: Add your bank details
          </p>
        </div> */}

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: " 205px" }}>
          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <p style={{ margin: 0, lineHeight: 1.8 }}>📞 Phone<br />📍 Address</p>
            <p style={{ margin: 0, lineHeight: 1.8 }}>
              {phone}
              <br />
              {address}
            </p>
          </div>

          <div style={{ marginTop: "60px" }}>
            <span
              style={{
                borderTop: "1px solid #000",
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              Authorized Sign
            </span>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: " 50px" }}>
            <p style={{ margin: 0, lineHeight: 1.8 }}>{state.description}</p>
            
        

         
        </div>


      </div>
    </div>

  </>

   );
}
);

export default InvoicePrint;
